import * as React from 'react';

const ItemTitle = () => (
    <div className="w-full text-center text-xs font-bold transition-colors duration-1000 select-none">
        Title
    </div>
);

export default ItemTitle;
